module.exports = __webpack_public_path__ + "static/media/start.05e0c120.jpg";